//
// SortContext.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../../moduleBuilder";
import ClosetObject from "../../../ClosetObject";
import "../../../lib";
import "./SortDirection";
import "./SortPreprocessing";

var SortContext = createModule("commons::SortContext", [], ClosetObject, [
    ,
    ,
    ,
    {
        preprocessing: 4,
        customSortValues: [7],
        rawColumnName: 7,
        direction: 4,
        columnName: 7,
    },
    ,
    {
        _create: [4],
    },
    ,
]);
export default SortContext;
